import api from "@/api/trading/apiTransact";
import { formatDecimal } from "@/utils/order";
import { selectedSymbolData } from "@/utils/symbol";
import axios from "axios";
import { commit } from "lodash-es";

export default {
  namespaced: true,
  state() {
    return {
      coinList: [],
      // ticker: "BTC",
      ticker: null,
      orderType: "",
      orderInfo: {},
      reCode: 0,
      previousPrice: 0,
      lastPrice: 0,
      bidPrice: 0,
      askPrice: 0,
      liqPrice: 0,
      countryCode: "",
      isBitget: false,
      symbolData: {},
      allSymbolData: [],
      coinPrice: 0,
      sizeType: "USDT",
      symbolPriceInfo: {},
      orderbookInfo: {},
      orderbookPrice: 0,
      isSocketConnecting: false,
      isDepthConnecting: false,
      tradeSocket: null,
      depthSocket: null,
      tradeVersion: 0,
      depthVersion: 0,
    };
  },
  mutations: {
    setCountryCode(state, payload) {
      state.countryCode = payload;
      // state.countryCode = "US";
      state.isBitget = ["US", "CN"].includes(state.countryCode);
    },
    setCoinList(state, payload) {
      state.coinList = payload;
    },
    setOrderInfo(state, payload) {
      const { type, ...orderInfo } = payload;
      state.orderType = type;
      state.orderInfo = orderInfo;
    },
    setReCode(state, payload) {
      state.reCode = payload;
    },
    setTicker(state, payload) {
      state.ticker = payload;
      // localStorage.setItem("ticker", payload ? payload : "BTC");
    },
    setLastPrice(state, payload) {
      state.previousPrice = state.lastPrice;
      state.lastPrice = payload; //실시간 현재가
    },
    setDepthPrice(state, payload) {
      state.bidPrice = payload.bidPrice;
      state.askPrice = payload.askPrice;
    },
    setOrderbookInfo(state, payload) {
      state.orderbookInfo = payload;
    },
    setSizeType(state, payload) {
      state.sizeType = payload;
    },
    setSymbolData(state) {
      state.symbolData = selectedSymbolData(state.ticker);
    },
    setCoinPrice(state, payload) {
      state.coinPrice = parseFloat(payload);
    },
    setSymbolPriceInfo(state, payload) {
      state.symbolPriceInfo = payload;
    },
    setLiqPrice(state, payload) {
      state.reCode = payload.reCode;
      state.liqPrice = payload.results?.liq_price;
    },
    setOrderbookPrice(state, payload) {
      state.orderbookPrice = payload;
    },
    setIsSocketConnecting(state, payload) {
      state.isSocketConnecting = payload;
    },
    setIsDepthConnecting(state, payload) {
      state.isDepthConnecting = payload;
    },
    setTradeSocket(state, socket) {
      state.tradeSocket = socket;
    },
    setDepthSocket(state, socket) {
      state.depthSocket = socket;
    },
    incrementTradeVersion(state) {
      state.tradeVersion++;
    },
    incrementDepthVersion(state) {
      state.depthVersion++;
    },
  },
  actions: {
    async fetchCoinList({ commit }) {
      try {
        const response = await api.getCoinList();
        if (response) {
          commit("setCoinList", response.tickers);
        }
      } catch (error) {
        return;
      }
    },
    async fetchPostLimitOrder({ state, commit }) {
      try {
        const queryString = new URLSearchParams(state.orderInfo).toString();
        const response = await api.postLimitOrder(state.orderType, queryString);
        commit("setReCode", response.reCode);
      } catch (error) {
        return;
      }
    },
    async fetchPostMarketOrder({ state, commit }) {
      try {
        let params;
        if (state.orderInfo?.price) {
          const { price, ...rest } = state.orderInfo;
          params = rest;
        } else {
          params = state.orderInfo;
        }
        const queryString = new URLSearchParams(params).toString();
        const response = await api.postMarketOrder(
          state.orderType,
          queryString
        );
        commit("setReCode", response.reCode);
      } catch (error) {
        return;
      }
    },
    async getSymbolPrecision({ state, commit }) {
      try {
        const symbol = `${state.ticker}USDT`;
        if (state.isBitget) {
          const response = await axios.get(
            `https://api.bitget.com/api/v2/mix/market/contracts?productType=usdt-futures`
          );
          state.allSymbolData = response?.data?.data;
        } else {
          const response = await axios.get(
            "https://fapi.binance.com/fapi/v1/exchangeInfo"
          );
          state.allSymbolData = response.data?.symbols;
        }
        commit("setSymbolData");
      } catch (error) {
        return;
      }
    },
    async getCoinPrice({ state, commit }) {
      const symbol = `${state.ticker}USDT`;
      if (state.isBitget) {
        const response = await axios.get(
          `https://api.bitget.com/api/v2/mix/market/ticker?productType=USDT-FUTURES&symbol=${symbol}`
        );
        const price = response.data.data[0].lastPr;
        commit("setCoinPrice", price);
      } else {
        const response = await axios.get(
          `https://fapi.binance.com/fapi/v1/ticker/price?symbol=${symbol}`
        );
        commit("setCoinPrice", response.data.price);
      }
    },
    async getSymbolPrice({ state, commit }) {
      const response = await api.getSymbolPrice(state.ticker);
      if (response) {
        commit("setSymbolPriceInfo", response.results[0]);
      }
    },
    async getCalculateLiqprice({ commit }, params) {
      const queryString = new URLSearchParams(params).toString();
      const response = await api.getCalculateLiqprice(queryString);
      if (response) {
        commit("setLiqPrice", response);
      }
    },
    async connectTradeSocket({ state, commit }, { updatePriceThrottled }) {
      commit("incrementTradeVersion");
      commit("setIsSocketConnecting", true);
      const currentVersion = state.tradeVersion;
      const pair = `${state.ticker}USDT`
  
      // 기존 소켓 종료
      if (state.tradeSocket) {
        const oldSocket = state.tradeSocket;
        oldSocket.onopen = null;
        oldSocket.onmessage = null;
        oldSocket.onerror = null;
        oldSocket.onclose = null;
        oldSocket.close();
      }
  
      // 새 소켓 연결
      let url, message;
      if (state.isBitget) {
        url = "wss://ws.bitget.com/v2/ws/public";
        message = JSON.stringify({
          op: "subscribe",
          args: [{ instType: "USDT-FUTURES", channel: "ticker", instId: pair }],
        });
      } else {
        url = `wss://fstream.binance.com/ws/${pair.toLowerCase()}@trade`;
        message = null;
      }
  
      const socket = new WebSocket(url);
      commit("setTradeSocket", socket);
  
      socket.onopen = () => {
        if (message) socket.send(message);
      };
  
      socket.onmessage = (event) => {
        if (currentVersion !== state.tradeVersion) return;
        if (state.isSocketConnecting) commit("setIsSocketConnecting", false);
        let data;
        try {
          data = JSON.parse(event.data);
        } catch (error) {
          console.error("Trade WebSocket parse error:", error);
          return;
        }
  
        let newPrice;
        if (state.isBitget) {
          if (!data?.data?.length) return;
          newPrice = parseFloat(data.data[0].lastPr);
        } else {
          newPrice = parseFloat(data.p);
        }
        if (!isNaN(newPrice)) updatePriceThrottled(newPrice);
      };
  
      socket.onerror = () => commit("setIsSocketConnecting", false);
      socket.onclose = () => commit("setIsSocketConnecting", false);
    },
  
    async connectDepthSocket({ state, commit }) {
      commit("incrementDepthVersion");
      commit("setIsDepthConnecting", true);
      const currentVersion = state.depthVersion;
      const pair = `${state.ticker}USDT`
      // 기존 소켓 종료
      if (state.depthSocket) {
        const oldSocket = state.depthSocket;
        oldSocket.onopen = null;
        oldSocket.onmessage = null;
        oldSocket.onerror = null;
        oldSocket.onclose = null;
        oldSocket.close();
      }
  
      let url, message;
      if (state.isBitget) {
        url = "wss://ws.bitget.com/v2/ws/public";
        message = JSON.stringify({
          op: "subscribe",
          args: [{ instType: "USDT-FUTURES", channel: "books5", instId: pair }],
        });
      } else {
        url = `wss://fstream.binance.com/ws/${pair.toLowerCase()}@depth20@100ms`;
        message = null;
      }
  
      const socket = new WebSocket(url);
      commit("setDepthSocket", socket);
  
      socket.onopen = async () => {
        if (message) socket.send(message);
  
        if (!state.isBitget) {
          // Binance 초기 depth snapshot
          const res = await fetch(`https://fapi.binance.com/fapi/v1/depth?symbol=${pair}&limit=5`);
          const data = await res.json();
          commit("setDepthPrice", {
            bidPrice: parseFloat(data?.bids?.[0]?.[0] ?? 0),
            askPrice: parseFloat(data?.asks?.[0]?.[0] ?? 0),
          });
        }
        commit("setIsDepthConnecting", false);
      };
  
      socket.onmessage = (event) => {
        if (currentVersion !== state.depthVersion) return;
  
        let data;
        try {
          data = JSON.parse(event.data);
        } catch {
          return;
        }
  
        let bidPrice, askPrice, bids = [], asks = [];
        if (state.isBitget) {
          const d = data.data?.[0];
          if (!d) return;
          asks = d.asks.map(([p,a]) => ({ price: parseFloat(p), amount: parseFloat(a) }));
          bids = d.bids.map(([p,a]) => ({ price: parseFloat(p), amount: parseFloat(a) }));
          bidPrice = parseFloat(d.bids[0][0]);
          askPrice = parseFloat(d.asks[0][0]);
        } else {
          asks = (data.a?.map(([p,a]) => ({ price: parseFloat(p), amount: parseFloat(a) })) || []).slice(0,12);
          bids = (data.b?.map(([p,a]) => ({ price: parseFloat(p), amount: parseFloat(a) })) || []).slice(0,12);
          bidPrice = parseFloat(data?.b?.[0]?.[0]);
          askPrice = parseFloat(data?.a?.[0]?.[0]);
        }
  
        commit("setDepthPrice", { bidPrice, askPrice });
        commit("setOrderbookInfo", { asks, bids });
      };
  
      socket.onerror = () => commit("setIsDepthConnecting", false);
      socket.onclose = () => commit("setIsDepthConnecting", false);
    },
  
    async disconnectAllSockets({ state, commit }) {
      if (state.tradeSocket) {
        state.tradeSocket.onopen = null;
        state.tradeSocket.onmessage = null;
        state.tradeSocket.onerror = null;
        state.tradeSocket.onclose = null;
        state.tradeSocket.close();
        commit("incrementTradeVersion");
        commit("setIsSocketConnecting", false);
      }
      if (state.depthSocket) {
        state.depthSocket.onopen = null;
        state.depthSocket.onmessage = null;
        state.depthSocket.onerror = null;
        state.depthSocket.onclose = null;
        state.depthSocket.close();
        commit("incrementDepthVersion");
        commit("setIsDepthConnecting", false);
      }
    }
  },
  getters: {
    getTicker: (state) => state.ticker,
  },
};
